import settings from '~/settings';
import { ngettext } from '~/helpers/localization';

import styles from './ClanLeaveDialog.scss';

export const ClanLeaveConfirmation = () => {
  const cooldown = settings.clanLeaveCooldown;
  if (!cooldown) {
    return null;
  }

  const cooldownDurationHours = cooldown / (60 * 60);

  const text = ngettext(
    'After leaving the Clan, you will be able to join another Clan or create a new one in %(amount)s hours.',
    'After leaving the Clan, you will be able to join another Clan or create a new one in %(amount)s hours.',
    cooldownDurationHours,
    {
      amount: cooldownDurationHours,
    },
  );

  return <div className={styles.confirmation}>{text}</div>;
};
